export default "__VITE_ASSET__C$JQRW7u__"